<template>
  <div :class="`${prefix}-option`">
    <span
      :id="labelElementId"
      ref="label"
      :class="`${prefix}-option__label`"
    >
      {{ option.display_name }}
    </span>
    <b-tooltip
      :key="labelElementId"
      :target="labelElementId"
      triggers="hover"
      container="body"
    >
      {{ tooltipText }}
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: 'MultiselectOptionSlot',

  props: {
    option: {
      type: Object,
      required: true
    },
    tooltipText: {
      type: String,
      default: ''
    },
    prefix: {
      type: String,
      default: 'multiselect'
    }
  },

  computed: {
    // Unique per component instance so duplicate option ids (or the same prefix on
    // two multiselects) never share a DOM id — b-tooltip resolves target via getElementById.
    labelElementId() {
      return `${this.prefix}-option-${this.option.id}-${this._uid}`;
    }
  },
};
</script>